<template>
  <div class="m-b-32" v-bind="$attrs">
    <WdsStack direction-column>
      <!-- When co-branded, the company name takes the brand accent colour and the tagline
           the brand heading colour; otherwise the default heading styling applies. -->
      <div class="tw-mb-4">
        <WdsHeading
          type="title1"
          :class="accentColor ? '' : 'tw-text-indigo-500'"
          :style="accentColor ? { color: accentColor } : {}"
        >
          {{ companyName }}
        </WdsHeading>
        <WdsHeading type="title1" :style="headingColor ? { color: headingColor } : {}">
          {{ $t('invited you to their talent pool!') }}
        </WdsHeading>
      </div>
      <WdsText large secondary>
        {{
          $t(
            'Create a Worksome account and use that chance to create an outstanding profile to get noticed and hired easily.',
          )
        }}
      </WdsText>
    </WdsStack>
  </div>
</template>

<script setup lang="ts">
import { WdsHeading, WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/composables/translation'

defineProps({
  companyName: {
    type: String,
    required: true,
  },
  // Optional co-brand colour overrides for the headings (empty keeps the default).
  accentColor: {
    type: String,
    default: '',
  },
  headingColor: {
    type: String,
    default: '',
  },
})
</script>
